<template>
  <div class="solution">
    <!-- banner部分 -->
    <div class="solution-banner">
      <div>
        <h2>解决方案</h2>
      </div>
    </div>
    <!-- 智慧校园 -->
    <div class="container clearfix">
      <div class="case-title">智慧校园</div>
      <div class="case-overview mb60">
        <div class="fl">
          <img src="../../assets/img/home/business_Image_one.png" alt="" />
        </div>
        <div class="fr">
          <p>斐宸智慧校园体系基于业务、数据双中台理念，建立共享开放能力平台，实现 能力开放和服务与数据的全生命周期治理；基于一云多端，混合云服务模式，覆盖 管理、生活、教学、科研和社会化服务全场景，让师生随时随地获得资源和服务； 围绕按主题建设，按场景上线，以评促建，可持续发展的路径，渐进建设全业务应 用场景，让智慧校园建设更简单。</p>
        </div>
      </div>
      <ul class="case-strength clearfix">
        <li><router-link to="/smartschool/cardIntegration">一卡通集成系统平台</router-link></li>
        <li><router-link to="/smartschool/faceRecognition">人脸识别安全通道闸机</router-link></li>
        <li><router-link to="/smartschool/carRecognition">车牌自动识别系统</router-link></li>
        <li><router-link to="/smartschool/monitoringSystem">监控系统</router-link></li>
        <li><router-link to="/smartschool/ledScreen">LED大屏显示系统</router-link></li>
        <li><router-link to="/smartschool/campuselEctronicfence">校园电子围栏系统</router-link></li>
        <li><router-link to="/smartschool/intelligentLift">智能升降柱系统</router-link></li>
        <li><router-link to="/smartschool/hdCampusTV">高清校园电视台</router-link></li>
        <li><router-link to="/smartschool/campusRadio">校园广播系统</router-link></li>
        <li><router-link to="/smartschool/wisdomClasscard">智慧电子班牌系统</router-link></li>
        <li><router-link to="/smartschool/wisdomRecordbroad">智能录播系统</router-link></li>
        <li><router-link to="/smartschool/intelligentChannel">智能通道翼闸</router-link></li>
      </ul>
    </div>
    <!-- 智慧社区 -->
    <div class="container clearfix">
      <div class="case-title">智慧社区</div>
      <div class="case-overview mb60">
        <div class="fl">
          <img src="../../assets/img/home/business_Image_three.png" alt="" />
        </div>
        <div class="fr">
          <p>斐宸智慧社区通过对辖区范围内的人员轨迹进行分析，对目标人员进行布控， 实现对社区 内可疑人员、可疑行为、可疑事件的及时发现和智能预警，可对海量多 维度数据资源进行碰撞分析和研判预警，实现多维数据查询和展示需求，将采集的 多维度信息 汇聚，结合街道其它业务信息形成数据资源仓库，对实时和历史信息进 行快速的 检索、查询和综合分析、展示。</p>
        </div>
      </div>
      <ul class="case-strength clearfix">
        <li><router-link to="/smartcommunity/intelligentScreen">智慧大屏</router-link></li>
        <li><router-link to="/smartcommunity/faceRecognition">人脸识别通道管理系统</router-link></li>
        <li><router-link to="/smartcommunity/emotionlessParking">无人值守无感支付停车</router-link></li>
        <li><router-link to="/smartcommunity/electricCarpile">社区电瓶车智能充电桩</router-link></li>
        <li><router-link to="/smartcommunity/wisdomBusinessSuper">智慧商场管理系统</router-link></li>
      </ul>
    </div>
    <!-- 智慧工地 -->
    <div class="container clearfix">
      <div class="case-title">智慧工地</div>
      <div class="case-overview mb60">
        <div class="fl">
          <img src="../../assets/img/home/gd_image.png" alt="" />
        </div>
        <div class="fr">
          <p>
            斐宸“互联网+”智慧工地，是将互联网+的理念和技术引入建筑工地，从施 工现场源头抓起，最大程度的收集人员、安全、环境、材料等关键业务数据，依托 物联网、互联网，建立云端大数据管理平台，形成“端+云+大数据”的业务体系 和新的管理模式，打通从一线操作与远程监管的数据链条，实现劳务、安全、环境、
            材料各业务环节的智能化、互联网化管理，提升建筑工地的精益生产管理水平。实 现“互联网+”与建筑工地的跨界融合，促进行业转型升级。
          </p>
        </div>
      </div>
      <ul class="case-strength clearfix">
        <li><router-link to="/smartbuilding/intelligentSite">智慧工地</router-link></li>
      </ul>
    </div>
    <!-- 智慧景区 -->
    <div class="container clearfix">
      <div class="case-title">智慧景区</div>
      <div class="case-overview mb60">
        <div class="fl">
          <img src="../../assets/img/home/jq_image.png" alt="" />
        </div>
        <div class="fr">
          <p>
            智慧景区就是利用云计算、物联网等新技术，通过互联网或移动互联网，借助 便携的终端上网设备，主动感知智慧景区的旅游资源、经济、活动和景区旅游者等 方面的信息并及时发布，让人们能够及时了解这些信息，及时安排和调整工作与景 区旅游计划，从而达到对各类景区旅游信息的智能感知、方便利用的效果，通过便 利的手段实现更加优质的服务，为景区插上腾飞的智慧化翅膀。
          </p>
        </div>
      </div>
      <ul class="case-strength clearfix">
        <li><router-link to="/smartScenic/scenicfarecollectionSystem">景区售检票系统</router-link></li>
        <li><router-link to="/smartScenic/scenicparkmanagerSystem">景区停车管理系统</router-link></li>
        <li><router-link to="/smartScenic/smartsceniccosumeSystem">景区消费系统</router-link></li>
        <li><router-link to="/smartScenic/smartnavigationSystem">智慧导览系统</router-link></li>
        <li><router-link to="/smartScenic/promotemarketSystem">宣传营销系统</router-link></li>
        <li><router-link to="/smartScenic/smartscenicspotdistributionSystem">智慧景区分销系统</router-link></li>
        <li><router-link to="/smartScenic/integratedbusinessmanagerSystem">综合业务管理系统</router-link></li>
        <li><router-link to="/smartScenic/bigdataanalyticsapplicationtypeSystem">大数据应用运行系统</router-link></li>
        <li><router-link to="/smartScenic/videofusionSystem">视频融合系统</router-link></li>
        <li><router-link to="/smartScenic/intelligentbroadcastSystem">智能广播系统</router-link></li>
        <li><router-link to="/smartScenic/intelligentvideosurveillanceSystem">智能视频监控系统</router-link></li>
        <li><router-link to="/smartScenic/environmentalmonitoringSystem">环境监测系统</router-link></li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Solution',
};
</script>
<style scoped>
.solution-banner {
  width: 100%;
  height: 594px;
  line-height: 594px;
  background: #000;
}
.solution-banner div {
  width: 100%;
  height: 100%;
  background: url(../../assets/img/solution/background_Image.png) no-repeat;
  background-size: cover;
}
.solution-banner h2 {
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.case-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.case-overview {
  width: 100%;
  height: 290px;
}
.case-overview .fl {
  width: 510px;
  height: 100%;
}
.case-overview .fl img {
  width: 100%;
  height: 100%;
}
.case-overview .fr {
  padding: 72px 0;
  width: 650px;
  height: 290px;
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.7;
}
.case-strength {
  display: table;
  margin-right: -40px;
}
.case-strength li {
  float: left;
  margin-right: 40px;
  margin-bottom: 40px;
  width: 270px;
  height: 60px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  background: url(../../assets/img/solution/Button.png);
}
.case-strength li a {
  color: #fff;
}
</style>
